import { Box, Stack } from 'braid-design-system';
import type { FC } from 'react';

import { Display } from 'src/libs/Display';

import { TableHeader } from './TableHeader';

import * as styles from './styles.css';

interface TableBodyLayoutProps {
  body: JSX.Element | JSX.Element[];
  pagination: JSX.Element | null;
}

export const TableLayout: FC<TableBodyLayoutProps> = ({ body, pagination }) => (
  <Stack space="xlarge">
    <Box className={styles.overflowX}>
      <Box className={styles.tableLayout}>
        <Display tablet desktop>
          <TableHeader />
        </Display>
        {body}
      </Box>
    </Box>
    {pagination}
  </Stack>
);
